<script>
export default {
  model: { prop: "page" },
  props: {
    first: {
      type: Boolean,
      required: true
    },
    last: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onKeydownListener(event) {
      if (event.keyCode === 39) {
        this.$emit("next");
      } else if (event.keyCode === 37) {
        this.$emit("prev");
      }
    }
  },
  created() {
    document.body.addEventListener("keydown", this.onKeydownListener);
  },
  beforeDestroy() {
    document.body.removeEventListener("keydown", this.onKeydownListener);
  }
};
</script>

<template>
  <div class="popup-pagination">
    <button v-if="!first" class="popup-pagination__prev" @click="$emit('prev')" />
    <button v-if="!last" class="popup-pagination__next" @click="$emit('next')" />
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/variables";

.popup-pagination {
  &__next,
  &__prev {
    cursor: pointer;
    outline: none;
    border: none;
    position: absolute;
    top: 50%;
    width: 48px !important;
    height: 48px !important;
    background-size: 17px 24px !important;
    margin: 0 !important;
  }

  &__next {
    background: url("~@/assets/icons/icon-pagination-right.svg") no-repeat center center !important;
    right: -65px;
  }

  &__prev {
    background: url("~@/assets/icons/icon-pagination-left.svg") no-repeat center center !important;
    left: -65px;
  }
}
</style>
